import { gql } from '@apollo/client';

export default gql`
  query hotelBooking($reference: String!) {
    hotelBooking(reference: $reference) {
      bookingCode
      pnr
      product
      originalPrice
      totalPrice
      priceBeforeMargin
      margin
      marginPercentage
      region {
        countryForVat
      }
      rooms {
        code
        from
        to
        duration
        dates {
          date
          originalPrice
          totalPrice
          priceBeforeMargin
          margin
          marginPercentage
        }
        originalPrice
        totalPrice
        priceBeforeMargin
        margin
        marginPercentage
        currencyShort
        roomTypeCode
        rateBasisId
        mealBasis {
          id
          name
        }
        roomName
        invoiced
        status
        adults
        children
        passengersDetails {
          code
          firstName
          lastName
          leading
        }
        cancellations {
          startDate
          endDate
          penalty
          refundPercentage
          refundType
        }
        errata {
          subject
          description
        }
        penaltiesApplied {
          valueBeforeMargin
          margin
          value
          type
          date
        }
      }
      hotel {
        id
        region
        regionName
        name
        slug
        country
        phone
        rating
        review {
          score
          description
          reviewsCount
        }
        location {
          longitude
          latitude
        }
        thumbnail {
          title
          src
        }
        hero {
          title
          src
        }
        genericImage {
          title
          src
        }
        address
        facilities {
          id
          name
          available
        }
        landmarks {
          name
          distance
          icon
          unit
        }
        overview
        internalImage {
          src
          title
        }
        internalExcerpt
        externalImage {
          src
          title
        }
        externalExcerpt
        tips
        images {
          title
          src
        }
        reviewInfo {
          score
          description
          reviewsCount
          summary
          goodToKnows {
            sentiment
            text
          }
          highlights {
            name
            score
            summary
            reviewsCount
            comments {
              text
              sentiment
            }
          }
          badges {
            text
          }
          travellerTypesBreakdown {
            tripType
            reviewsPercent
          }
          reviewScoreBreakdown {
            reviewScore
            reviewsPercent
          }
        }
      }
    }
  }
`;
